import { render, staticRenderFns } from "./SalesDashboardFilters.vue?vue&type=template&id=39ff8fc1&"
import script from "./SalesDashboardFilters.vue?vue&type=script&lang=js&"
export * from "./SalesDashboardFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports